import { cn } from '../../lib/utils';

interface AgentBadgeProps {
  name: string;
  size?: 'sm' | 'md';
  className?: string;
}

export function AgentBadge({ name, size = 'sm', className }: AgentBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded font-mono font-medium tracking-wide bg-brand-navy text-brand-lime',
        size === 'md' ? 'text-[11px] px-2 py-[3px]' : 'text-[10px] px-[6px] py-[1px]',
        className
      )}
    >
      <span aria-hidden>✦</span>
      {name}
    </span>
  );
}
